import styled, { css } from 'styled-components'

import { TypeStyle, fromMd, untilMd } from '@syconium/little-miss-figgy'

export const Container = styled.div<{ faded?: boolean }>`
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 24px 0;
  opacity: ${props => (props.faded ? '0.4' : '1')};
`

export const Title = styled(TypeStyle.HeadlineExtraExtraSmall)<{ parentIsLink?: boolean }>`
  font-size: 14px;
  margin-bottom: 8px;
  overflow: hidden;

  ${fromMd} {
    font-size: 13px;
  }

  &:hover {
    text-decoration: ${o => (o.parentIsLink ? 'underline' : 'unset')};
  }
`

export const Info = styled.div``

export const BadgesWrapper = styled.div`
  margin-top: 10px;
`

export const HighlightsContainer = styled.div`
  display: flex;
  align-items: flex-start;
`

export const OptionsContainer = styled.div``

export const Thumbnail = styled.div`
  background: 'transparent';
  box-sizing: content-box;
  height: 80px;
  margin-top: auto;
  margin-bottom: auto;
  ${untilMd} {
    padding: 0 16px;
  }

  ${fromMd} {
    padding-right: 16px;
  }
  width: 80px;
  z-index: 0;

  img {
    object-fit: contain;
  }
`

export const ImagePlaceholder = styled.div`
  background: ${o => o.theme.color.deprecated.stoneLighter};
  height: 80px;
  width: 80px;
`

export const ReviewCountCopy = styled.div`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  margin-inline-end: 8px;
  text-align: end;
`

export const ColorsSectionWrapper = styled.div`
  ${untilMd} {
    width: 100%;
  }

  .fresnel-container {
    position: unset !important;
  }
`

export const ViewDetailsButton = styled(TypeStyle.HeadlineMicro)`
  cursor: pointer;
  margin-top: 8px;
  text-decoration: underline;
  color: ${o => o.theme.color.text.tertiary.on.background};
`
export const ReviewStarIconContainer = styled.div`
  display: flex;
`

export const ReviewCountTextContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-inline-start: 8px;
`

export const ReviewStarsContainer = styled.div`
  align-items: center;
  display: flex;
  margin-top: 8px;
`

export const ReviewStars = styled.div<{
  rating: number
  isLarge?: boolean
}>`
  display: inline-block;
  font-family: Times;
  font-size: ${o => (o.isLarge ? '16px' : '13px')};
  line-height: 1;

  &::before {
    ${o => {
      const percentage = `${(o.rating / 5) * 100}%`
      return css`
        background: linear-gradient(
          90deg,
          currentColor ${percentage},
          ${o.theme.color.deprecated.stoneLight} ${percentage}
        );
      `
    }}
    background-clip: text;
    -webkit-background-clip: text;
    content: '★★★★★';
    letter-spacing: 3px;
    -webkit-text-fill-color: transparent;
  }

  .rtl & {
    transform: scaleX(-1);
  }
`
